import React, { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateTitle } from "@features/titleSlice";
import { mainContext } from "@ts/constants";
import ReportFiltersLayout from "@components/wrappers/layouts/ReportFiltersLayout";
import ProductAnalysisModule from "@components/widget-modules/ProductAnalysisModule";

const ProductDeepdive: React.FC = () => {
    const dispatch = useDispatch();
    const { selectedSKU, setSelectedSKU, resetReviewFilters } =
        useContext(mainContext);

    useEffect(() => {
        dispatch(updateTitle("Product Deep Dive For SKU"));
        return () => resetReviewFilters();
    }, []);

    return (
        <ReportFiltersLayout reviewsLoader={false}>
            <ProductAnalysisModule
                defaultActiveModule="overview"
                {...{
                    selectedSKU,
                    setSelectedSKU,
                }}
            />
        </ReportFiltersLayout>
    );
};

export default ProductDeepdive;